// Backend Laravel. LOCAL por defecto; en el build de producción se pasa REACT_APP_API_URL.
// (ej. REACT_APP_API_URL=https://hans-prueba.rocazit.com npm run build)
export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
// API del AGENTE de IA (el chat hace POST `${apiAI}/askai`).
// LOCAL: el agente odonto corre en el puerto 8001. Se puede sobreescribir con REACT_APP_AI_URL.
export const apiAI = process.env.REACT_APP_AI_URL || "http://localhost:8001";
// Identificador de ESTE frontend/doctor: el agente guarda perfil y memoria de chat
// separados por doctor (y RUTEA al backend de ese doctor). Se pasa por env en cada build nuevo:
//   REACT_APP_DOCTOR_ID=odonto-yabeta  REACT_APP_DR_NAME="Dr. Victor Yabeta"  npm run build
// Sin env, quedan los valores de María Eugenia (default).
export const doctorId = process.env.REACT_APP_DOCTOR_ID || "odonto-maria-eugenia";
export const drName = process.env.REACT_APP_DR_NAME || "Dra. Maria Eugenia Camacho Crapuzzi";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";
